/**
 * @prettier
 */

import Navigator from "../../../components/Navigator";
import OutOfRecaptures from "../../../components/Messages/OutOfRecaptures";
import Header from "../../../components/Header";

const OutOfRetryAttemptsState = ({
    onContinue,
    message,
    navigationAction,
    navigationProps,
}) => (
    <>
        <Header />
        <OutOfRecaptures continue={onContinue} message={message} />
        <Navigator
            page={"document_capture"}
            action={navigationAction}
            propsToPass={navigationProps}
        />
    </>
);

export default OutOfRetryAttemptsState;
